import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";
import { takePostLoginRedirect } from "@/lib/postLoginRedirect";

export function LoginForm() {
  const navigate = useNavigate();
  const { user, loading: authLoading } = useAuth();
  const [isOAuthLoading, setIsOAuthLoading] = useState(false);

  useEffect(() => {
    if (!authLoading && user) {
      navigate(takePostLoginRedirect(), { replace: true });
    }
  }, [user, authLoading, navigate]);

  const handleMicrosoftLogin = async () => {
    setIsOAuthLoading(true);
    try {
      const { error } = await supabase.auth.signInWithOAuth({
        provider: "azure",
        options: {
          redirectTo: window.location.origin,
          scopes: "openid email profile User.Read offline_access Calendars.ReadWrite Schedule.Read.All",
        },
      });
      if (error) throw error;
    } catch (error) {
      toast.error((error as Error).message || "Erro ao fazer login com Microsoft");
      setIsOAuthLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center gap-6">
      <Button
        type="button"
        className="w-full h-12 text-base font-medium bg-gray-800 hover:bg-gray-900 text-white"
        disabled={isOAuthLoading}
        onClick={handleMicrosoftLogin}
      >
        {isOAuthLoading ? (
          <>
            <Loader2 className="mr-2 h-5 w-5 animate-spin" />
            Redirecionando...
          </>
        ) : (
          <>
            <svg className="mr-2 h-5 w-5" viewBox="0 0 21 21" fill="none">
              <rect x="1" y="1" width="9" height="9" fill="#F25022" />
              <rect x="11" y="1" width="9" height="9" fill="#7FBA00" />
              <rect x="1" y="11" width="9" height="9" fill="#00A4EF" />
              <rect x="11" y="11" width="9" height="9" fill="#FFB900" />
            </svg>
            Entrar com Microsoft
          </>
        )}
      </Button>

      <p className="text-xs text-gray-500 text-center leading-relaxed">
        Ao fazer login, você concorda com nossos{" "}
        <Link to="#" className="text-primary hover:text-primary/80 underline transition-colors">
          Termos de Uso
        </Link>{" "}
        e{" "}
        <Link to="#" className="text-primary hover:text-primary/80 underline transition-colors">
          Política de Privacidade
        </Link>
      </p>
    </div>
  );
}
